export default __webpack_public_path__ + "static/media/slack.3225d0d2.webp";